import { eachDayOfInterval, format, startOfDay } from "date-fns";

export interface WorkOrderReservation {
  start_date: string;
  end_date: string;
  platform: string | null;
}

/** Guest is staying on this calendar day (checkout day end_date is free). */
export function isDateBooked(date: Date, reservations: WorkOrderReservation[]): boolean {
  const d = format(date, "yyyy-MM-dd");
  return reservations.some((r) => r.start_date <= d && r.end_date > d);
}

/** True if any day in [start, end] overlaps a reservation stay. */
export function visitRangeConflictsWithReservations(
  start: Date,
  end: Date,
  reservations: WorkOrderReservation[]
): boolean {
  if (reservations.length === 0) return false;
  const days = eachDayOfInterval({ start: startOfDay(start), end: startOfDay(end) });
  return days.some((day) => isDateBooked(day, reservations));
}
